<template>
  <BaseModal
    v-if="isShowing"
    color="grey"
    rounded
    dropShadow
    class="dataset-delete-dialog"
  >
    <div class="dataset-delete-dialog__container">
      <header class="dataset-delete-dialog__header">
        <h1>Are you sure?</h1>
      </header>
      <section class="dataset-delete-dialog__body">
        <div v-if="hasConsulting">
          <h2
            v-if="hasConsulting && hasDatacast"
            class="dataset-delete-dialog__subtitle"
          >
            Consulting Data
          </h2>
          <p>
            If you continue, a request will be sent to ITR Economics to move the
            following dataset(s) to
            <span class="bold">archive.</span>
          </p>
          <ul class="dataset-delete-dialog__body-list">
            <li
              v-for="(item, index) in consultingList"
              :key="`dialog-consulting-list-item-${index}`"
            >
              {{ item.Name }}
              <span v-if="item.UsedIn" class="italic">
                - Used in {{ item.UsedIn }}
              </span>
            </li>
          </ul>
          <p v-if="hasConsulting && hasDatacast">
            Once archived, Consulting datasets are no longer available for you
            to view or edit in My Data. You will also no longer have access to
            any associated Saved Charts in DataCast, if applicable. There will
            be no option to reverse this action. Please note that this action
            will not immediately be apparent on our website. An economist will
            review your request and may reach out to you with questions.
          </p>
          <p v-else>
            Once archived, datasets are no longer available for you to view or
            edit in My Data. You will also no longer have access to any
            associated Saved Charts in DataCast, if applicable. There will be no
            option to reverse this action. Please note that this action will not
            immediately be apparent on our website. An economist will review
            your request and may reach out to you with questions.
          </p>
        </div>
        <div v-if="hasDatacast">
          <h2
            v-if="hasConsulting && hasDatacast"
            class="dataset-delete-dialog__subtitle"
          >
            DataCast Data
          </h2>
          <p>
            If you continue, the following dataset(s) will be
            <span class="bold">deleted permanently.</span>
          </p>
          <ul class="dataset-delete-dialog__body-list">
            <li
              v-for="(item, index) in datacastList"
              :key="`dialog-datacast-list-item-${index}`"
            >
              {{ item.Name }}
            </li>
          </ul>
          <p v-if="hasConsulting && hasDatacast">
            Once permanently deleted, Datacast datasets are no longer available
            in My Data or DataCast. You will also no longer have access to any
            associated Saved Charts in DataCast, if applicable. There will be no
            option to reverse this action.
          </p>
          <p v-else>
            Once permanently deleted, datasets are no longer available in My
            Data or DataCast. You will also no longer have access to any
            associated Saved Charts in DataCast, if applicable. There will be no
            option to reverse this action.
          </p>
        </div>
      </section>
      <footer class="dataset-delete-dialog__footer">
        <button
          type="button"
          class="dataset-delete-dialog__button dataset-delete-dialog__button--confirm"
          @click="__confirm()"
        >
          CONTINUE
        </button>
        <button
          type="button"
          class="dataset-delete-dialog__button dataset-delete-dialog__button--cancel"
          @click="__cancel()"
        >
          CANCEL
        </button>
      </footer>
    </div>
  </BaseModal>
</template>

<script>
  import BaseModal from '~/components/base/BaseModal.vue';

  export default {
    name: 'DatasetDeleteDialog',
    components: {
      BaseModal,
    },
    props: {
      size: {
        type: String,
        required: false,
        default: 'md',
        validator: (value) => {
          const SIZES = ['sm', 'md', 'lg'];
          return SIZES.includes(value);
        },
      },
    },
    data: () => ({
      isShowing: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
      consultingList: [],
      datacastList: [],
    }),
    computed: {
      hasConsulting() {
        return this.consultingList && this.consultingList.length > 0;
      },
      hasDatacast() {
        return this.datacastList && this.datacastList.length > 0;
      },
    },
    methods: {
      prompt({ consultingList = [], datacastList = [] }) {
        this.consultingList = consultingList;
        this.datacastList = datacastList;

        this.isShowing = true;

        return new Promise((resolve, reject) => {
          this.resolvePromise = resolve;
          this.rejectPromise = reject;
        });
      },
      __confirm() {
        this.isShowing = false;
        this.resolvePromise(true);
      },
      __reject() {
        this.isShowing = false;
        this.rejectPromise(true);
      },
      __cancel() {
        this.isShowing = false;
        this.resolvePromise(false);
      },
    },
  };
</script>

<style lang="scss" scoped>
  :deep(.base-modal__content) {
    overflow: hidden;
  }
  .bold {
    font-weight: 700;
  }
  .italic {
    font-style: italic;
  }
  .dataset-delete-dialog {
    &__subtitle {
      margin: 10px 0;
      padding: 5px 0;
      border-bottom: 2px solid var(--itr-blue);
      font-style: italic;
      font-weight: 700;
      font-size: 16px;
    }
    &__container {
      height: 100%;
      max-height: 80vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0;
      margin: 0;
    }

    &__header {
      display: flex;
      justify-content: center;
      background-color: transparent;
      width: 100%;
      text-align: center;
    }
    &__body {
      flex: 1 auto;
      background-color: transparent;
      width: 100%;
      padding: 25px 0;
      overflow-y: auto;
    }
    &__body-list {
      color: #585b60;
      font-weight: 700;
    }
    &__footer {
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 25px;

      background-color: transparent;
      padding: 15px;
      width: 100%;
    }

    &__button {
      padding: 10px 25px;
      border-radius: 6px;
      width: 100%;
      max-width: 225px;
      text-transform: uppercase;
      cursor: pointer;
      font-weight: 700;

      background-color: #cccccc;
      color: var(--itr-blue);

      &--confirm {
        background-color: #9d0404;
        color: #f1f2f3;
      }
      &--cancel {
        background-color: #757575;
        color: #f1f2f3;
      }
    }
  }
</style>
